import { NamingTypeEnum } from './naming-type.enum';

export class NamingTypeModel {
  project = NamingTypeEnum.OnlyName;
  order = NamingTypeEnum.OnlyName;
  customer = NamingTypeEnum.OnlyName;

  constructor(namingTypes?: {
    project: NamingTypeEnum;
    order: NamingTypeEnum;
    customer: NamingTypeEnum;
  }) {
    if (namingTypes) {
      this.project = namingTypes.project;
      this.order = namingTypes.order;
      this.customer = namingTypes.customer;
    }
  }
}
